<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
     
      <CRow class="justify-content-center">
        <CCol md="4">
          <CCard class="mx-4 mb-0 box-shadow">
            <CCardBody
              class="p-4"
              style="
                background: #fff;
                border-bottom-left-radius: 15px;
                border-bottom-right-radius: 15px;
              "
            >
              <CForm class="mt-3">
                <div v-if="ErrorMessage == true" class="">
                  <CAlert show color="danger">
                    <strong class="text-danger mr-2">{{ Message }} </strong>
                  </CAlert>
                </div>
                <div v-if="SuccessMessage == true" class="">
                  <CAlert show color="success"
                    >{{ Message }}.</CAlert
                  >
                </div>
                <h5 class="text-center text-muted">Welcome to Sign Up:</h5>
               

                <br />
                <div
            style="
              width: 100%;
              height: 20px;
              border-bottom: 1px solid #d8dbe0;
              text-align: center;
            "
            class="mb-4"
          >
            <span
              style="font-size: 15px; background-color: #fff; padding: 0 10px;font-weight:bold"
            >
              User's Info
            </span>
          </div>
                <br />
                <CInput
                  type="text"
                  v-model="name"
                  placeholder="Enter your Name"
                />
                <CInput
                  type="text"
                  v-model="email"
                  placeholder="Enter your Email"
                />
                <CInput
                  type="text"
                  v-model="phone"
                  placeholder="Enter your Phone"
                />
                <CInput
                  type="password"
                  v-model="password"
                  autocomplete="nope"
                  placeholder="Enter your Password"
                />

                <input type="checkbox" @click="AddNew()" v-model="checked" />
                Register Student <br />
                <br />
                <div v-if="checked">
                   <div
            style="
              width: 100%;
              height: 20px;
              border-bottom: 1px solid #d8dbe0;
              text-align: center;
            "
            class="mb-4"
          >
            <span
              style="font-size: 15px; background-color: #fff; padding: 0 10px;font-weight:bold"
            >
              Student Info
            </span>
          </div>
                  <br />
                  <CRow>
                    <CCol sm="12" lg="12">
                      <CInput
                        type="text"
                        v-model="FullName"
                        placeholder="Enter Student Name"
                      />
                    </CCol>
                    <CCol sm="12" lg="12">
                      <CInput
                        type="text"
                        placeholder="Enter Your Age"
                        v-model="Age"
                      />
                    </CCol>
                    <CCol sm="12" lg="12" class="text-left">
                      <v-select
                        v-model="SelectedGrade"
                        :options="grades"
                        label="GradeName"
                        placeholder="--Please Select Grade--"
                      ></v-select>
                    </CCol>
                    <CCol sm="4" lg="4" class="mt-3">
                      <h6 class="text-left text-dark">Gender</h6>
                    </CCol>
                    <CCol sm="8" lg="8" class="text-left mt-3">
                      <input type="radio" v-model="gender" value="Female" />
                      <span class="text-dark"> Female</span>
                      <input
                        type="radio"
                        class="text-dark ml-3"
                        v-model="gender"
                        value="Male"
                      />
                      <span class="text-dark"> Male</span>
                    </CCol>
                  </CRow>
                </div>

                <CButton
                  block
                  class="mt-4 custom-btn"
                  color="success"
                  size="lg"
                  @click="InsertSignUp"
                  style="border-radius: 5px"
                  >Sign Up</CButton
                >

                <hr />
                <CButton color="link" class="px-0" @click="GoToLogin()"
                  >Back to Login</CButton
                >
              </CForm>
            </CCardBody>
          </CCard>
          <div class="text-center mt-3">
            <label class="text-muted">Privacy Policy</label>
          </div>
        </CCol>
      </CRow>
    </CContainer>
    <div class="outer d-sm-down-none">
      <img style="max-width: 400px" src="../assets/img/login.png" />
    </div>

    <!-- <div class="outer-right">
      <img style="max-width: 350px" src="../assets/img/online.png" />
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import backgroundUrl from "../assets/img/bgApps.png";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
      name: "",
      email: "",

      phone: "",
      password: "",
      Error: false,
      Message: "",
      noteModal: true,

      backgroundUrl,
      SuccessMessage: false,
      ErrorMessage: false,

      checked: false,
      TuitionCenterCode: "2075",
      Age: "",
      ParentName: "",
      Age: "",
      gender: "",
      MainContactNumber: "",
      FullName: "",
      grades: [],

      SelectedGrade: "",
    };
  },
  async mounted() {
    this.GetGrade();
  },
  methods: {
    GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    GoToHome() {
      this.$router.push("/Dashboard");
    },
    GoToLogin() {
      this.$router.push("Login");
    },
    InsertSignUp() {
      var currentUrl = window.location.hash;

      let id = currentUrl;
      var join = "codeId";
      var quiz = "quizId";

      let quizID = id.includes(quiz);
      let codeid = id.includes(join);

      console.log("id" + id);
      console.log("quizId" + quizID);
      console.log("codeid" + codeid);

      const formData = new FormData();

      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("password", this.password);

      formData.append("userType", "parent");
      formData.append("phone", this.phone);

      return this.$API
        .post(this.$SignUp, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Message = response.data.Message;
            this.userId = response.data.UserId;

            if (this.FullName == "") {
              this.SuccessMessage = true;

              if (quizID == true) {
                window.open(
                  "https://pickiddo.com/OnlineClass/#/Login?targetUrl=%2FQuizStudent%3FquizId%3D" +
                    this.$route.query.quizId,
                  "_self"
                );
              }
              if (codeid == true) {
                window.open(
                  "https://pickiddo.com/OnlineClass/#/Login?targetUrl=%2FJoinGroup%3FcodeId%3D" +
                    this.$route.query.codeId,
                  "_self"
                );
              }
              if (quizID == false && codeid == false) {
                this.$router.push("Login");
              }
            } else {
              this.RegisterStudent(this.userId);
            }
          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        });
    },
    async AddNew() {
      this.formNew = true;
    },
    RegisterStudent() {
      var currentUrl = window.location.hash;

      let id = currentUrl;
      var join = "codeId";
      var quiz = "quizId";

      let quizID = id.includes(quiz);
      let codeid = id.includes(join);

      console.log("id" + id);
      console.log("quizId" + quizID);
      console.log("codeid" + codeid);

      const formData = new FormData();

      formData.append("Name", this.FullName);
      formData.append("ParentPhoneNumber", this.phone);
      formData.append("Grade", this.SelectedGrade.GradeName);
      formData.append("ParentName", this.name);
      formData.append("ParentEmail", this.email);

      return this.$API
        .post(this.$RegisterManualStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            if (response.data > 0) {
              this.SuccessMessage = true;
              if (quizID == true) {
                window.open(
                  "https://pickiddo.com/OnlineClass/#/Login?targetUrl=%2FQuizStudent%3FquizId%3D" +
                    this.$route.query.quizId,
                  "_self"
                );
              }
              if (codeid == true) {
                window.open(
                  "https://pickiddo.com/OnlineClass/#/Login?targetUrl=%2FJoinGroup%3FcodeId%3D" +
                    this.$route.query.codeId,
                  "_self"
                );
              }
              if (quizID == false && codeid == false) {
                this.$router.push("Login");
              }
            } else {
              this.ErrorMessage = true;
            }
          } else if (response.status == 500) {
            this.ErrorMessageNotComplete = true;
          } else {
            this.ErrorMessageNotComplete = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.ErrorMessageNotComplete = true;
          }
        });
    },
  },
};
</script>
